// removed by extract-text-webpack-plugin
module.exports = {"component":"_17-LgJboNbkgwVtm-HB9RB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Physical/QuantityForm/quantityForm.css
// module id = 1049
// module chunks = 2